import React from 'react'

// Props for the SvgIcon component
interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  src: string
}

// Use NodeJS.Require with context properly typed
declare const require: {
  context(
    directory: string,
    useSubdirectories: boolean,
    regExp: RegExp
  ): {
    <T = any>(id: string): T
    keys(): string[]
  }
}

const SvgIcon: React.FunctionComponent<SvgIconProps> = ({ src, ...props }) => {
  // Dynamically import all SVGs in the icons folder
  const iconsContext = require.context('../icons', true, /\.svg$/)

  // Import the specific SVG component
  const ImportedIcon = iconsContext(`./${src}.svg`).default as React.FunctionComponent<React.SVGProps<SVGSVGElement>>

  return <ImportedIcon {...props} />
}

export default SvgIcon
